import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TopupServiceService } from '../Services/topup-service.service';
import { AuthService } from '../Services/auth.service';
import { CommonService } from '../Services/common.service';
import { CookieService } from '../Services/cookie';
import { CardServiceService } from '../Services/card-service.service';

@Component({
  selector: 'app-pay-card-success',
  templateUrl: './pay-card-success.component.html',
  standalone:false,
  styleUrls: ['./pay-card-success.component.scss']
})
export class PayCardSuccessComponent implements OnInit {
  flow: string;
  prodType: string;
  Screen: string;
  quickPayFlow: string;
  product: string ;

  constructor(private cookieService: CookieService, private route: ActivatedRoute, public datepipe: DatePipe, public topup: TopupServiceService, private _router: Router, private auth: AuthService, private commonP: CommonService, private topupservice: TopupServiceService, private cardService: CardServiceService) { }
  PaymentID: string = '';
  result: string = ''
  currentDate: Date = new Date();
  time: number = new Date().getTime();
  amount: string;
  Service: string = ''
  RequestLetter: boolean = false
  pendingRequest: boolean = false
  RefId: string = ""
  Email: string = ""
  SelectedinternalId: string = ""
  Servicetype: string = ""
  Referenceid: string = ""
  Product: string = "";


  async ngOnInit(): Promise<any> {

    // this.quickPayFlow = this.cookieService.get("QuickPay1", false);  
    // console.log("QuickPayflohere", this.quickPayFlow)

    // let Q = this.cookieService.get("QuickPay1",false);
    // if(Q){
    //   this.quickPayFlow = Q;
    //   console.log("QuickPayflohere", this.quickPayFlow)
    // }

    this.quickPayFlow = localStorage.getItem('quickPayFlow');
    console.log("QuickPayflohere", this.quickPayFlow)

    // this.product = localStorage.getItem('Product');
    // console.log("prod12", this.product)

    let S =await this.cookieService.get("Screen",false);
    if(S){
      this.Screen = S;
    }
    if(this.auth.detailuser){
    this.commonP.presentLoading();
    this.auth.accessToken = await this.commonP.Get("token");
  await  this.auth.VerifyToken({}, this.auth.accessToken).then((data: any) => {

      if (data?.response?.code == 1) {

        // this.UpdatePayment()
        this.commonP.hideLoading();
      } else {

        this.commonP.hideLoading();
        if (this.flow != 'Quickpay') {
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }


      }


    })
  }
  else{
    console.log("pre-login");
    
  }

    this.route.queryParams.subscribe(params => {

      console.log("params", params)
      if (params['paymentId']) {

        this.PaymentID = params['paymentId'];
        console.log("this.PaymentID", this.PaymentID)


      }

      if (params['result']) {

        this.result = params['result'];

      }

      if (params['type']) {

        this.RequestLetter = true;

      }
    });
    this.amount =await this.cookieService.get("amount", true);   // decrypted value
    console.log("this.amount", this.amount)
    this.Service =await this.cookieService.get("sr", true);   // decrypted value
    console.log("this.Service", this.Service)
    this.SelectedinternalId =await this.cookieService.get("internalid", true);
    console.log("SelectedinternalId", this.SelectedinternalId)
    this.Servicetype =await this.cookieService.get("ServiceType", true);
    this.Referenceid =await this.cookieService.get("referenceId", true);
    console.log("Referenceid", this.Referenceid)
    this.Product =await this.cookieService.get("Product", true);
    console.log("Product", this.Product)

    this.RequestLetter =await this.cookieService.get("ReqLetter", true) == 'ReqLetter' ? true : false;   // decrypted value




    let f =await this.cookieService.get("flow", true);
    if (f) {
      this.flow = f;
    }


    let P =await this.cookieService.get("prodType", true);
    if (P) {
      this.prodType = P;
    }

  

  }
  Dashboard() {

    // this.cookieService.deleteAll("/");
    this.cookieService.delete("at");
    this.cookieService.delete("sr");
    if (this.topup.InititePaymentObject) {

      this.topup.clearInititePaymentObject();
      // this.cookieService.remove('at');
      // this.cookieService.remove('sr');
      // this.cookieService.removeAll();
      this._router.navigateByUrl('/DashboardCreditCards');



    } 
    else if (this.quickPayFlow.includes("Quick")) {
      this._router.navigateByUrl('/LoginWithIdNum');
      // this.topup.clearValidatePaymentObject();
      // this.cookieService.remove('at');
      // this.cookieService.remove('sr');
      // this.cookieService.removeAll();
      // this.commonP.clearLogout();
     

    }
    else if (this.topup.ValidatePaymentObject) {

      this.topup.clearValidatePaymentObject();
      // this.cookieService.remove('at');
      // this.cookieService.remove('sr');
      // this.cookieService.removeAll();
      this.commonP.clearLogout();
      this._router.navigateByUrl('/LoginWithIdNum');

    }
  



  }

  Return() {

    this.cookieService.delete("Refid");
    this.cookieService.delete("email");
    this.cookieService.delete("flow");

if (this.prodType == 'C') {
      this._router.navigateByUrl('/DashboardCreditCards');
      this.cookieService.delete("prodType")

    }
    else if (this.prodType == 'L') {
      this._router.navigateByUrl('/DashboardLoans');
      this.cookieService.delete("prodType")

    }
    
    else{
      this._router.navigateByUrl('/DashboardCreditCards');
    }

  }

  ReturnLoan(){
    this._router.navigateByUrl('/LoginWithIdNum');
  }
  Returnprelogin(){

this._router.navigateByUrl('/LoginWithIdNum');
  }
  // Request Letter Once Payment Done For Both RequestLetter Card / Loan
  LettersRequest() {

    let data = {
      internalId: this.SelectedinternalId,
      ServiceType: this.Servicetype,
      Product: this.Product, // C for card, L for loan
    };
    this.cardService.RequestingLetters(data, this.auth.accessToken).then(async (data: any) => {
      if (data?.response?.code == 1) {

        if (data?.response?.content?.card?.referenceNumber !== '') {
          this.RefId = data?.response?.content?.card?.referenceNumber;

        } else if (data?.response?.content?.loan?.referenceNumber !== '') {
          this.RefId = data?.response?.content?.loan?.referenceNumber;

        }
        await this.commonP.hideLoading();


      } else {
        await this.commonP.hideLoading();
        this.commonP.ParseErrorAlert('', '', this._router, data);
      }
    })

  }
  // Update Payment for Request and letter on behave of product and card id
  async UpdatePayment() {

    let body = {
      referenceId: this.Referenceid,
      internalId: this.SelectedinternalId,
      ServiceType: this.Servicetype,
      Product: this.Product, // C for card, L for loan
    };

    this.topupservice.UpdatePaymentService(this.auth.accessToken, body).then((data: any) => {

      if (data?.response?.code == 1) {
        this.Email = data?.response?.content?.email
        this.commonP.hideLoading();
        // this.LettersRequest();
      } else {
        this.commonP.hideLoading();
        this.commonP.ParseErrorAlert('', '', this._router, data);

      }

    })


  }


}

